//@getters

import { GetterTree } from "vuex";
import { nationalLicenseState } from "./state";

export const getters: GetterTree<any, nationalLicenseState> = {};
